// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "* {\n  \n}\n", "",{"version":3,"sources":["styles.css"],"names":[],"mappings":"AAAA;;AAEA","file":"styles.css","sourcesContent":["* {\n  \n}\n"]}]);
// Exports
module.exports = exports;
